export const content = "Changing clients back to Active is easy: Just schedule another session with them from your calendar. They\u2019ll reappear in your Active clients.\n";
